import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import type { Bitrix24CalendarProps } from "./types";

export const details = {
  name: "Bitrix24Calendar",
  description: "Bitrix24 calendar widget with your meetings and their notes",
  tags: ["Business", "Calendar", "Bitrix24"],
  category: "Bitrix24",
  grid: {
    large: [6, 4],
  },
  app: lazy(() => import("./App").then(m => ({ default: m.App }))),
  integrationsUsed: ["bitrix24"],
  defaultProps: {
    size: "medium",
    defaultRange: "week",
  },
} as ElementDetails<Bitrix24CalendarProps>;
